module.exports = __webpack_public_path__ + "457f15db43f824a1c5c64f370b44f190.svg";